// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import LevelMeter from '../../components/LevelMeter';
import Button from '../../components/Button';
import TopBg from './assets/Banner.png';
import Column from '../../components/Column';
import InfoText from '../../components/NewCard/components/InfoText';
import CheckBox from '../../components/CheckBox';

const otherS = {
  Container: styled.div`
    width: 100%;
    max-width: 1366px;
    margin: 0 auto;
  `,
  LoadingContainer: styled.div`
    display: flex;
    margin-top: auto;
    place-content: center;
  `,
  WrapperTop: styled.div`
    background: transparent url(${(props: { bannerUrl?: string; }) => props.bannerUrl ? props?.bannerUrl : TopBg}) 0% 0% no-repeat padding-box;
    background-size: cover;
    padding: 24px 60px 26px 60px;
    display: flex;
    place-content: center;
    justify-content: center;
  `,
  LeftWrapper: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 484px;
    flex: 1;
  `,
  RightWrapper: styled.div`
    max-width: 560px;
    flex: 1;
    position: relative;
  `,
  Badge: styled.img`
    position: absolute;
    left: -19px;
    transform: translateX(-100%);
  `,
  Information: styled.div`
    flex: 1;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    color: #434343;
    margin-top: 8px;
    margin-bottom: 22px;
    margin-right: 0px;
    margin-left: 0px
  `,
  Point: styled.span`
    color: #EF8200;
  `,
  Info: styled.div`
    display: flex;
    align-items: center;
    color: #434343;
  `,
  LevelMeter: styled(LevelMeter)`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
  `,
  Title: styled.h1`
    font-weight: bold;
    font-size: 28px;
    line-height: 41px;
    color: #434343;
  `,
  Time: styled.span`
    margin-top: 8px;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    color: #666666;
  `,
  Domains: styled.div`
    margin-top: 17px;
    font-size: 12px;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: 0em;
  `,
  Button: styled(Button)`
    width: 192px;
  `,
  Body: styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    padding: 24px 60px 0 60px;
    place-content: center;
    justify-content: center;
  `,
  InfoBox: styled.div`
    flex-shrink: 0;
    width: 255px;
    display: flex;
    flex-direction: column;

    & > * + * {
      margin-top: 36px;
    }
  `,
  Contents: styled.div`
    margin-left: 51px;
    flex: 1;
  `,
  InfoText: styled(InfoText)`
    display: flex;
    align-items: center;
    font: 14px Noto Sans TC;
    color: #313131;

    img {
      width: 20px;
      height: 20px;
      margin-right: 4px;
    }
  `,
  TimeUpContainer: styled(Column)`
    height: 100%;

    > * + * {
      margin-top: 36px;
    }
  `,
  TimeUp: styled.p`
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #313131;
  `,
  Img: styled.img``,
  TimeUpButton: styled(Button)`
    width: 142px;
    height: 44px;
  `,
  DownloadResultContainer: styled.div`
  `,
  DownloadButtonContainer: styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  `,
  DownloadLoadingContainer: styled.div`
    width: 192px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  DownloadText: styled.div`
    width: 192px;
    text-align: center;
    color: #313131;
  `,
  DownloadButton: styled.a`
    color: #EF8200;
  `,
  ErrorText: styled.div<{ downloadError:boolean }>`
    ${props => props.downloadError ? `
      text-align: center;
      color: red;
      display: block;
      width: 192px;
    ` : 'display: none;'}
  `,
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
  `,
  ChooseDownloadWapper: styled.div`
    background: #FFFFFF;
    border-radius: 11px;
    margin-top: 11px;
    position: fixed;
    font-size: 26px;
    line-height: 38px;
    color: #353535;
    top: 10%;
    left: 50%;
    transform: translate(-51%,0%);
  `,
  ChooseDownloadCard: styled.div`
    padding: 20px 80px;
    text-align: center;
  `,
  CloseBar: styled.div`
    background: #EF8200;
    border-radius: 11px 11px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  CloseIconContainer: styled.div`
    padding: 0px 17px 4px;
    cursor: pointer;
  `,
  CloseIcon: styled.div`
    display: inline-block;
    width: 14px;
    height: 2px;
    background: #FFF;
    line-height: 0;
    font-size: 0;
    vertical-align: middle;
    transform: rotate(45deg);
    &::after {
      content: "/";
      display: block;
      width: 14px;
      height: 2px;
      background: #FFF;
      transform: rotate(-90deg);
    }
  `,
  ChooseDownloadContent: styled.div`
    margin: 10px 0px 30px 60px;
    display: flex;
    flex-direction: column;
    max-height: 300px;
    overflow-y: auto;
    & :first-child {
      margin-left: -17px;
      padding-bottom: 8px;
    }
    &::-webkit-scrollbar {
      width: 7px;
    }
    &::-webkit-scrollbar-button {
      background: transparent;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #E6E6E6;
      border: 1px solid #E6E6E6;
    }
    &::-webkit-scrollbar-track {
      box-shadow: transparent;
    }
  `,
  ChooseDownloadTitle: styled.p`
    color: #353535;
    font-size: 20px;
  `,
  SubmitAction: styled.div`
    display: flex;
    justify-content: center;
  `,
  CancelButton: styled(Button)`
    background: #7A7A7A;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 7px 0px 0px 7px;
    padding: 4px 27px;
    margin-right: 14px;
  `,
  SubmitButton: styled(Button)`
    background: #EF8200;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 0px 7px 7px 0px;
    padding: 4px 27px;
  `,
  MemberCheckBox: styled(CheckBox)`
    justify-content: flex-start;
    color: #767676;
    padding: 3px 0 3px 20px;
  `,
  MemberCheckBoxText: styled.div`
  `,
  EmptyUserText: styled.div`
    font-size: 18px;
  `,
};
export const S = {
  ...otherS,
}
